/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallVariable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M22 13c0-1.868-.686-4.582-2.388-6.85C17.88 3.84 15.095 2 11 2v2c3.406 0 5.62 1.494 7.013 3.35C19.435 9.248 20 11.534 20 13zm-4 0c0-1.201-.436-2.915-1.512-4.35C15.379 7.173 13.594 6 11 6v2c1.906 0 3.12.827 3.888 1.85C15.685 10.915 16 12.201 16 13zM6.618 16.963 2.226 22.2h2.518l2.954-3.687 1.76 3.687h2.386l-2.537-5.048 4.146-4.897h-2.5L8.248 15.62l-1.515-3.365H4.27z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCallVariable as CallVariable };
